import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../core/http/settings.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {trigger, style, animate, transition, state} from '@angular/animations';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-obs-tt-result',
  templateUrl: './obs-tt-result.component.html',
  styleUrls: ['./obs-tt-result.component.scss'],
  animations: [
    trigger('simpleFadeAnimation', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({opacity: 1})),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({opacity: 0}),
        animate(300 )
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(300, style({opacity: 0})))
    ])
  ]
})
export class ObsTTResultComponent implements OnInit {

  items: any = [];
  isLoading = true;
  Errors = null;
  data = null;
  templates;
  temp;
  isVisible = false;
  filteredItems;
  mode = "form";
  itemSelected;
  service;
  private _searchText:string ;

  get searchText(): string {
      return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filteredItems = this.filterItems(value)
}

filterItems(searchString: string) {
    return this.items.filter( item =>
      item.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
}

  htmlContent = "";

  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '300px',
      minHeight: '300px',
      maxHeight: '300px',
      width: 'auto',
      minWidth: 'auto',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
      ]
    ],
};

Form = new FormGroup({
  Id: new FormControl(null, Validators.required),
  Mode: new FormControl('THIRD_TRIMESTER', Validators.required),
  Name: new FormControl('', Validators.required),
  Item_Of_Service_Id: new FormControl('', Validators.required),
  Template_Text: new FormControl(0, Validators.required),
});
templateForm = new FormGroup({
  Id: new FormControl(null, Validators.required),
  Mode: new FormControl('THIRD_TRIMESTER', Validators.required),
  Name: new FormControl('', Validators.required),
  Item_Of_Service_Id: new FormControl('', Validators.required),
  Template_Text: new FormControl(0, Validators.required),
});

  // templates = [
  //   {
  //     name: "Deployment",
  //     message: `<div style="text-align: center;"><b>LETTER FOR DEPLOYMENT</b></div><div style="text-align: center;"><b><br></b></div><div><br></div>dear [[Name]],<div>You have been deployed to [[LocationName]],</div><div><br></div><div><br></div><div>Effective Date: [[StartDate]],</div><div><br></div><div><br></div><div>Administrator</div><div>[[Organization]]</div>`,
  //   },
  //   {
  //     name: "birthday",
  //     message: `<div style="text-align: center;"><br></div><div><br></div>dear [[Name]],<div>On this special day of yours, we want to wish you a happy birthday,</div><div><br></div><div><br></div><div>Thank You,</div><div><br></div><div><br></div><div>Signed</div><div>Management</div>`,
  //   }
  // ];


  constructor(public auth: SettingsService, private _snackBar: MatSnackBar) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    console.log(this.templateForm.value)
    const {
      Id,
      Mode,
      Name,
      Item_Of_Service_Id,
      Template_Text,
    } = this.templateForm.value;
    this.auth
      .postDocument(
        Id,
        Mode,
        Name,
        Item_Of_Service_Id,
        Template_Text,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess)

          if (this.data.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
            this.templateForm.reset()
          }
          else {
            this.isLoading = false;
            this.Errors = "Not successful, please try again" 
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false; 
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  Submit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    console.log(this.templateForm.value)
    const {
      Id,
      Mode,
      Name,
      Item_Of_Service_Id,
      Template_Text,
    } = this.Form.value;
    this.auth
      .postDocument(
        Id,
        Mode,
        Name,
        Item_Of_Service_Id,
        Template_Text,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;
          console.log(resSuccess)

          if (this.data.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
            this.templateForm.reset()
          }
          else {
            this.isLoading = false;
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false; 
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  ngOnInit(): void {

    this.auth
    .gettemplatesDetail(205)
    .subscribe(
      (resSuccess) => {
        this.temp = resSuccess
        this.Form.patchValue({
          Name: this.temp.Name,
          Template_Text: this.temp.Template_Text,
          Id: this.temp.Id
        });
        this.isLoading = false;
        console.log(resSuccess)
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      } 
    );

    this.auth
      .getItems()
      .subscribe(
        (resSuccess) => {

          this.items = resSuccess
          this.filteredItems = this.items
          this.isLoading = false;
        },
        (resErr) => {
        } 
      );

      this.auth
      .gettemplates()
      .subscribe(
        (resSuccess) => {

          this.templates = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }

  setTemplate(template) {
    this.Form.patchValue({
      MessageBody: template.Template_Text,
    });
  }
  getTemplate(item) {
    this.isLoading = false;
    this.Form.patchValue({
      MessageBody: "Loading....."
    });
    this.auth
      .gettemplatesDetail(item.id)
      .subscribe(
        (resSuccess) => {
          this.temp = resSuccess
          this.Form.patchValue({
            MessageBody: this.temp.Template_Text
          });
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }

  togle() {
    this.isVisible = !this.isVisible
  }
  getResultTemplate(id) {
    console.log(id)
    this.auth
    .getDocByServiceId(id)
    .subscribe(
      (resSuccess) => {
        console.log(resSuccess)
        this.service = resSuccess
        if (resSuccess) {
          this.Form.patchValue({
            // MessageBody: this.service.Template_Text,
            Id: this.service?.Id,
            Name: this.service?.Name,
            Item_Of_Service_Id: this.service?.Item_Of_Service_Id,
            Template_Text:  this.service?.Template_Text,
          });
          this.isLoading = false;
          this.isVisible = false;
        }else {
          this.isVisible = false;
          this._snackBar.open('No template for this service', '', {
            duration: 2000,
            verticalPosition: 'top',
          }); 
        }
      },
      (resErr) => {
        this.isLoading = false;
        console.log(resErr)
        this.Errors = resErr;
        this.isVisible = false;
        this._snackBar.open('No template for this service', '', {
          duration: 2000,
          verticalPosition: 'top',
        }); 
      } 
    );
  }
  setitem(item) {
    this.templateForm.patchValue({
      Item_Of_Service_Id: item.id,
    });
    this,this.isVisible = false;
    this.itemSelected = item.name
  }

}
